import React, { Component } from "react";
import eye from "../assets/eye.svg";
import eyeClosed from "../assets/eyeClosed.svg";

export default class Input extends Component {

  static defaultProps = {
    isTextarea: false,
  };
  state = {
    showPassword: false,
  };

  toggleShowPassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };

  showPasswordIcon = () =>
    this.state.showPassword ? (
      <img src={eyeClosed} alt="Hide" />
    ) : (
      <img src={eye} alt="Show" />
    );

  renderPasswordButton = () => {
    if (this.props.type === "password") {
      return (
        <button
          type="button"
          className="abs_btn"
          onClick={this.toggleShowPassword}
        >
          {this.showPasswordIcon()}
        </button>
      );
    }
    return null;
  };

  dataList = () => {
    if (this.props.dataList) {
      return (
        <datalist id={this.props.label.replace(/\s+/g, "_")}>
          {this.props.dataList.map((item, index) => (
            <option key={index} value={item.name} data-index={index}>
              {item.name}
            </option>
          ))}
        </datalist>
      );
    }
    return null;
  };

  onChangeAction = (ev) => {
    if (this.props.onChangeAction) {
      this.props.onChangeAction(ev.currentTarget.value);
    } else if (this.props.onChange) {
      this.props.onChange(ev);
    }
  };

  error = () =>
    this.props.error ? <p className="err">{this.props.error}</p> : null;

  render() {
    const inputType =
      this.props.type === "password"
        ? this.state.showPassword
          ? "text"
          : "password"
        : this.props.type === "number"
          ? "text"
          : this.props.type;

    return (
      <div className="input-rapper" {...this.props}>
        {this.props.label && (
          <p
            className="label"
            style={{ opacity: this.props.hidelabel ? "0" : "1" }}
          >
            {this.props.label}
          </p>
        )}

        {/* <input
          id={this.props.id}
          name={this.props.name}
          autoFocus={!!this.props.autoFocus}
          list={this.props.dataList ? this.props.label.replace(/\s+/g, "_") : undefined}
          type={inputType}
          inputMode={this.props.type === "number" ? "numeric" : undefined}
          pattern={this.props.type === "number" ? "[0-9]*" : undefined}
          onChange={this.onChangeAction}
          onInput={(e) => {
            if (this.props.type === "number") {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }
          }}
        /> */}

        {this.props.isTextarea ? (
          <textarea className="input" {...this.props} style={{ resize: 'none' }} />
        ) : (

            <input
              // value={this.props.value}
              id={this.props.id}
              name={this.props.name}
              autoFocus={!!this.props.autoFocus}
              list={this.props.dataList ? this.props.label.replace(/\s+/g, "_") : undefined}
              type={inputType}
              inputMode={this.props.type === "number" ? "numeric" : undefined}
              pattern={this.props.type === "number" ? "[0-9]*" : undefined}
              defaultValue={this.props.defaultValue ?? this.props.value} // fallback for uncontrolled input
              // value={this.props.value !== undefined ? this.props.value : undefined} // only use if provided
              onChange={this.onChangeAction}
              onInput={(e) => {
                if (this.props.type === "number") {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }
              }}
              disabled={this.props.disabled}
              required={this.props.required}
              min={this.props.min}
          />)}


        {this.dataList()}
        {this.renderPasswordButton()}
        {this.error()}
      </div>
    );
  }
}
